import React from "react";

const DemographicsMainController = props => {
  const {
    history,
    audienceSchema,
    audienceDemographs,
    createAudienceDemograph,
    refetchAudienceDemographs,
    deleteAudienceDemograph,
    refetchAudienceCount,
    refetchAudienceSchema,
    loadingAudienceCount,
    loadingAudienceSchema,
    loadingAudienceDemographs,
  } = props;

  const submitAudience = async data => {
    await createAudienceDemograph({
      variables: {
        name: data.name,
        description: data.description,
        tags: data.tags,
        metrics: data.metrics,
        reachCount: data.reachCount,
      },
    });
  };

  const deleteAudience = async id => {
    await deleteAudienceDemograph({
      variables: {
        id: id,
      },
    });
  };

  // Request Device Count of the Audience parameter selected by the user
  const fetchAudienceCount = async params => {
    const response = await refetchAudienceCount({
      metric: params,
    });

    return response;
  };

  return (
    <React.Fragment>
      {React.cloneElement(props.children, {
        history,
        audienceSchema,
        audienceDemographs,
        refetchAudienceDemographs,
        refetchAudienceSchema,
        loadingAudienceCount,
        loadingAudienceSchema,
        loadingAudienceDemographs,
        submitAudience,
        deleteAudience,
        fetchAudienceCount,
      })}
    </React.Fragment>
  );
};

export default DemographicsMainController;
